<template>
    <div class="container-fluid">
        <div class="card">
            <div class="card-header d-flex align-items-center">
                <FileEdit :size="24" class="me-2" />
                <h4 class="mb-0">Documents</h4>
            </div>
            <div class="card-body">
                <ul class="nav nav-tabs mb-3">
                    <li class="nav-item">
                        <a 
                            class="nav-link" 
                            :class="{ active: activeTab === 'templates' }"
                            href="#"
                            @click.prevent="activeTab = 'templates'"
                        >
                            <span class="badge" :class="activeTab === 'templates' ? 'tab-badge-active' : 'tab-badge'">Form Templates</span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a 
                            class="nav-link" 
                            :class="{ active: activeTab === 'submissions' }"
                            href="#"
                            @click.prevent="activeTab = 'submissions'"
                        >
                            <span class="badge" :class="activeTab === 'submissions' ? 'tab-badge-active' : 'tab-badge'">Submissions</span>
                        </a>
                    </li>
                </ul>

                <div v-if="activeTab === 'templates'">
                    <FormDatatable />
                </div>
                <div v-else-if="activeTab === 'submissions'">
                    <SubmittedDatatable />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { FileEdit } from "lucide-vue-next";
import FormDatatable from "./FormDatatable.vue";
import SubmittedDatatable from "./SubmittedDatatable.vue";

const activeTab = ref<'templates' | 'submissions'>('templates');
</script>

<style scoped>
.card-header {
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
}

/* Tab badge styling */
.tab-badge {
    background-color: #e9ecef;
    color: #495057;
    font-weight: 500;
    padding: 0.35em 0.65em;
}

.tab-badge-active {
    background-color: #3B9796;
    color: #fff;
    font-weight: 500;
    padding: 0.35em 0.65em;
}

.nav-link {
    border: none;
    background: transparent;
}

.nav-link:hover .tab-badge {
    background-color: #3B9796;
    color: #fff;
}
</style>
